import { Component, ViewChild, OnInit, Input } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { NgForm } from '@angular/forms';
import * as ngswal from "sweetalert";
import { GlobalConstants } from '../common/global-constants';
import { customfunctions, DataParam } from '../common/customfunctions';
import { FileToUpload } from '../file-upload/file-to-upload.model';
import { ArticleModel } from './article-model';
import { ApiMethod } from '../apimethods/api-method';
import { zip } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { ArticleinfoComponent } from '../articleinfo/articleinfo.component';
declare var $;

@Component({
  selector: 'app-article',
  templateUrl: './article.component.html',
  styleUrls: ['./article.component.css']
})
/** Article component*/

export class ArticleComponent {

  /** Article ctor */
  modelItem: ArticleModel = new ArticleModel();
  http: HttpClient;
  showModal: boolean;
  showInfoModal: boolean; showInfoMetadataModal: boolean;
  showAuthorModal: boolean;
  showFundingModal: boolean;
  title: string;
  infoTitle: string;
  articleNotes: string;
  dataTable: any;
  dtAuthor: any;
  dtFunding: any;
  dtOptions: any;
  dtFile: any;
  nAuthIndex: number;
  nFundIndex: number;
  articleNo: string;
  articleTitle: string;
  articleSubTitle: string;
  articleType: string;
  authors: string;
  author: string;
  authorEMail: string;
  copyright: string;
  copyrightYear: string;
  volume: string;
  issue: string;
  pubDate: string;
  ePubDate: string;
  notes: string;
  isHold: boolean;
  holdType: string;
  license: string;
  public allocateUserId: boolean = false; showCorrepSelect: boolean = false;
  public allocatedId: string;
  public lVolumeList: any;
  public lSubjectList: any;
  public lArticleTypeList: any;
  public lJournalList: any;
  public lStatusList: any;
  public lAuthorList: any;
  public lFundingList: any;
  public lFileList: string[] = [];
  fileBase64: string = "";
  articleId: number;
  tableData = [];
  fileToUpload: File = null;
  fileCount: number = 0;
  filePath: any;
  files: string[] = [];
  firstReleaseArticleId: string;
  @ViewChild('dataTable') table;
  @ViewChild('dtAuthor') dtTable;
  @ViewChild('dtFunding') dtFundingTable;
  @ViewChild('chkHold') chkHoldRelease;
  monthNames = ["Jan", "Feb", "Mar",
    "Apr", "May", "Jun",
    "Jul", "Aug", "Sep",
    "Oct", "Nov", "Dec"];
  dataSet: any;
  dataSetFunding: any;
  filterStatus: string = 'All'; filterQueryType: string = '';
  ngOnInit() {
    customfunctions.SetDateValues('#Txt_FromDate', '#Txt_ToDate');
    $("#lstJournals").select2({
      placeholder: "Select Journal", dropdownParent: "#divMainFilter"
    }); $("#lstJournals").val([]).trigger("change");

    $("#ddlStatus").select2({
      placeholder: "Select Status", dropdownParent: "#divMainFilter"
    }); $("#ddlStatus").val([]).trigger("change");

    $("#lstVolume").select2({
      placeholder: "Select Volume", dropdownParent: "#divMainFilter"
    });
    $("#lstVolume").val([]).trigger("change");

    $("#lstIssue").select2({
      placeholder: "Select Issue", dropdownParent: "#divMainFilter"
    });
    $("#ddlDataField,#ddlPressPak").select2({
      placeholder: "All", dropdownParent: "#divMainFilter"
    });

    $("#lstIssue").val([]).trigger("change");

    ApiMethod.getBaseUrl();

    this.route.queryParamMap.subscribe(params => {
      if (params.get("type") != null) {
        if (params.get("type") == 'proof') {
          this.filterQueryType = params.get("type");
          this.filterStatus = 'Correction from Author';
        }
      }
    });
  }

  constructor(private router: Router, private route: ActivatedRoute) {
    ApiMethod.getPageConfig().subscribe(
      data => {
        this.modelItem = <ArticleModel>data["ArticlePage"];
        localStorage.aEID = 0;
        $('#ddlField').select2({ placeholder: "Select", dropdownParent: ".divContainer" });
        $('#ddlMailTo').select2({ placeholder: "Select", dropdownParent: ".divContainer" });

        //this.getStatusList();
        this.getArticleList();
        this.getJournalsList();
      }, error => {
        ngswal("Warning !", error.message, "warning");
      });
  }

  showInfoPopUp(): void {
    $('#btnPopupartMeta').trigger('click');
  }

  GetDataByActiveTab(tabName) {
    this.lStatusList = null;
    this.getArticleList(false, false, tabName);
  }
  getArticleList(skipLoading = false, stateSave = false, loadType = ''): void {
    if (!skipLoading) {
      $("#LoadingImage").show();
    }
    var fromDate = $('#Txt_FromDate').val();
    var toDate = $('#Txt_ToDate').val();

    if (fromDate == "" || toDate == "")
      fromDate = $('#Txt_FromDate').val();
    toDate = $('#Txt_ToDate').val();

    var selectedStatus = '';
    if ($("#ddlStatus").val() != null) {
      selectedStatus = $("#ddlStatus").val().toString();
    }
    if (selectedStatus == "")
      selectedStatus = 'All';

    var selectedField = $("#ddlField option:selected").val();
    if (selectedField == "")
      selectedField = 'All';

    let filterLoadType = $('#TabulArticleList .active').attr('name');
    if (loadType != '') {
      filterLoadType = loadType;
    }

    var articleData = {
      Journals: ($("#lstJournals").val() ?? "").toString(),
      Volume: $("#lstVolume option:selected").text() ?? "",
      Issue: $("#lstIssue option:selected").text() ?? "",
      LoginId: localStorage.aLoginID ?? "",
      PublisherId: localStorage.aPubID ?? "",
      fromDate: fromDate?.toString() ?? "",
      toDate: toDate?.toString() ?? "",
      selectedStatus: selectedStatus ?? "",
      selectedField: selectedField ?? "",
      PressPak: $("#ddlPressPak").val() ?? "",
      LoadType: filterLoadType ?? ""
    };

    ApiMethod.postMethod(this.modelItem.articleListApi, articleData).subscribe(
      result => {
        if (this.lStatusList == null) {
          this.lStatusList = result.artStatusList;
        }

        if (this.filterQueryType == 'proof') {
          let dataFilter = this.getQueryFilterData(result.aArticleList, this.filterStatus);
          result.aArticleList = dataFilter;
        }

        try {
          this.dataSet = JSON.stringify(result.aArticleList); // Data List
          this.dataSet = JSON.parse(this.dataSet);
          this.dataTable = $(this.table.nativeElement);
          //Dynamic datable
          let aColList = result.aColListL;
          let dataItem = new DataParam();
          dataItem.acolList = aColList;
          dataItem.aNewButtonName = 'btn_AddNew';
          dataItem.dataTable = this.dataTable;
          dataItem.dataset = this.dataSet;
          dataItem.dtheight = (GlobalConstants.size.height - 320);
          dataItem.modulename = 'ArticleModule';
          dataItem.infoPopupID = 'ID';
          dataItem.StateSave = stateSave;
          this.dataTable = customfunctions.dynamicDataTable(dataItem);
          //Dynamic datable
        } catch (e) {

        }
        $("#LoadingImage").hide();
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      });

  }

  getQueryFilterData(dataItem, status) {
    return dataItem.filter(v => v.Status === status);
  }
  getFiltered() {
    this.getArticleList();
  }

  resetFilter() {
    this.filterQueryType = 'All';
    $("#lstJournals").val(0).change();
    $('#ddlStatus').val("All").change();
    $('#ddlField').val("All").change();
    $("#ddlPressPak").val("All").change();
    this.getArticleList();
    customfunctions.SetDateValues('#Txt_FromDate', '#Txt_ToDate');
  }


  public allocate(): void {

    if (this.allocateUserId) {
      this.allocateUserId = false;
      return;
    }
    if (localStorage.rowIdVal != "") {
      if (localStorage.colName != "Allocation") {
        let colName = localStorage.colName.replace('TWIS', 'ISIO');
        ngswal({
          title: "Update Confirmation !",
          text: "Do you want to update the " + colName + " value ?",
          type: "info",
          showCancelButton: true,
          confirmButtonColor: "#DD6B55",
          confirmButtonText: "Yes, Update!",
          cancelButtonText: "No, Cancel!",
          closeOnConfirm: false,
          closeOnCancel: false
        },
          function (isConfirm) {
            if (isConfirm) {
              $("#LoadingImage").show();
              $('#btnArticleAllocate').trigger("click");
            } else {
              $('input[data-idavalue="' + localStorage.rowIdVal + '"][data-colname="' + localStorage.colName + '"]').
                prop('checked', (localStorage.dropId == '0' ? true : false));
              ngswal("Cancelled !", "You clicked cancel! :)", "warning");
            }
          });

      }
      else {
        var tranStatus = "";
        var userID = "";
        var articleData = {
          ArticleId: localStorage.rowIdVal
        };

        ApiMethod.postMethod(this.modelItem.transactionApi, articleData).subscribe(
          result => {

            let itemL = result.aTransItem;
            tranStatus = itemL[0].Status;
            userID = itemL[0].UserID;
            this.allocatedId = userID;
            if (tranStatus == "InProcess") {
              ngswal("Failed !", "Article already in process. you can't allocate this article", "warning");
              this.allocateUserId = true;
              $('select[data-idavalue="' + localStorage.rowIdVal + '"]').val(userID).change();
              $("#LoadingImage").hide();

            }
            else {
              ngswal({
                title: "Are you confirm to allocate article?",
                text: "Article Allocate Confirmation !",
                type: "info",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Yes, Allocate!",
                cancelButtonText: "No, Cancel!",
                closeOnConfirm: false,
                closeOnCancel: false
              },
                function (isConfirm) {
                  if (isConfirm) {
                    $('#btnArticleAllocate').trigger("click");
                  } else {
                    ngswal("Cancelled !", "You clicked cancel! :)", "warning");
                    $('#btnArticleAllocateCancel').trigger("click");

                  }
                });

              $("#LoadingImage").hide();
            }
          },
          error => {
            ngswal("Failed !", error.message, "warning");
            $("#LoadingImage").hide();
          }
        );
      }
    }
  }

  articleAllocateCancel() {
    this.allocateUserId = true;
    $('select[data-idavalue="' + localStorage.rowIdVal + '"]').val(this.allocatedId).change();
    $("#LoadingImage").hide();
    return false;
  }

  articleAllocate() {
    ngswal({
      title: 'Please wait processing!.....',
      text: '',
      showCancelButton: false,
      showConfirmButton: false
    });
    var aItemL = {
      LoginId: localStorage.aLoginID,
      ArticleId: localStorage.rowIdVal,
      AllocateUserId: localStorage.dropId,
      ColName: localStorage.colName,
      ColNameValue: localStorage.colNameValue
    }
    ApiMethod.postMethod(this.modelItem.allocationApi, aItemL).subscribe(
      result => {
        if (result.status) {
          ngswal({
            position: 'top-end',
            type: "success",
            title: "Status Updated",
            text: result.message,
            showConfirmButton: false,
            timer: 1500
          });
          $("#LoadingImage").hide();
        } else {
          $("#LoadingImage").hide();
          ngswal("Failed !", result.message, "warning");
        }
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      });
  }

  setDateValues() {
    var now = new Date();

    var currentDay = ("0" + now.getDate()).slice(-2);
    var currentMonth = ("0" + (now.getMonth() + 1)).slice(-2);
    var currentDate = now.getFullYear() + "-" + (currentMonth) + "-" + (currentDay);
    $('#Txt_ToDate').val(currentDate);

    var preDate = new Date(now.setDate(now.getDate() - 7));
    var prevDay = ("0" + (preDate.getDate())).slice(-2);
    var prevMonth = ("0" + (preDate.getMonth() + 1)).slice(-2);
    var prevToday = preDate.getFullYear() + "-" + (prevMonth) + "-" + (prevDay);
    $("#Txt_FromDate").val(prevToday);
  }

  journalList: any;
  issueList: any;
  volumeList: any;

  getJournalsList() {
    ApiMethod.getMethod(this.modelItem.GetJournalList + "/" + localStorage.aPubID + "/" + localStorage.aLoginID).subscribe(
      result => {
        this.journalList = result.aitemJournalList;

      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      });
  }

  getVolumeIssue() {
    var journals = $("#lstJournals").val().toString();

    ApiMethod.getMethod(this.modelItem.VolumeIssueListAPI + "/" + journals).subscribe(
      result => {
        this.volumeList = result.volumeList;
        this.issueList = result.issueList;

        $("#lstIssue").val(-1).trigger("change");
        $("#lstVolume").val(-1).trigger("change");

      }, error => {
        $("#LoadingImage").hide();
      });
  }


}


